import axios, { AxiosInstance, AxiosResponse, AxiosError } from "axios";

import { Area, Store, VacancyArea, VacancyRoom, AnalysisAreaStaytimeAverage, StoreContract } from "throne-api";
import { FacilityVacancy } from "vacancy";

const $http: AxiosInstance = axios.create({
    baseURL: process.env.VUE_APP_THRONE_API_BASE_URL,
    timeout: 100000,
});

export async function fetchStoreByStoreName(storeName: string): Promise<Store | null> {
    return await $http
        .get(`/stores/baseUrl/${storeName}`)
        .then((response: AxiosResponse) => response.data.items.shift() as Store | null)
        .catch((error: AxiosError) => {
            return Promise.reject(
                error.response ? error.response.data.errors : { message: "connection error", name: "" },
            );
        });
}

export async function fetchStoreContractByStoreName(storeName: string): Promise<StoreContract | null> {
    return await $http
        .get(`/stores/baseUrl/${storeName}/contract`)
        .then((response: AxiosResponse) => response.data.items.shift() as StoreContract | null)
        .catch((error: AxiosError) => {
            return Promise.reject(
                error.response ? error.response.data.errors : { message: "connection error", name: "" },
            );
        });
}

export async function fetchAreaListByStoreId(storeId: number): Promise<Area[]> {
    return await $http
        .get(`/stores/${storeId}/areas`)
        .then((response: AxiosResponse) => response.data.items as Area[])
        .catch((error: AxiosError) => {
            return Promise.reject(
                error.response ? error.response.data.errors : { message: "connection error", name: "" },
            );
        });
}

export async function fetchVacancyAreaListByStoreId(storeId: number): Promise<VacancyArea[]> {
    return await $http
        .get(`/stores/${storeId}/vacancy`)
        .then((response: AxiosResponse) => response.data.items as VacancyArea[])
        .catch((error: AxiosError) => {
            return Promise.reject(
                error.response ? error.response.data.errors : { message: "connection error", name: "" },
            );
        });
}
